import React from 'react'
import Hdata from "../Data/Hdata"
function Health() {
  return (
    <div className="container">
      <div className="row pt-4">
        <div className="col-lg-12">
          <div className="border py-3">
            <div className="row pt-2 px-3 mb-5">
              {Hdata.map((a) => (
                <div className="col-lg-6 mt-5">
                  <div className="card himage position-relative">
                    <img className="w-100" src={a.img} />
                    <div className="card-body">
                      <a href="#">
                        <h6 className="text-dark fw-semibold health fs-5">{a.title}</h6>
                      </a>
                      <div className="d-flex text-secondary">
                        <i class="bi bi-clock-fill fs-6"></i>
                        <p className=" ps-2">November 16 , 2017</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
     <nav aria-label="Page navigation example">
  <ul className="pagination mt-3">
    <li className="page-item"><a className="page-link me-2" href="#">Previous</a></li>
    <li className="page-item"><a className="page-link me-2" href="#">1</a></li>
    <li className="page-item"><a className="page-link link me-2" href="#">2</a></li>
    <li className="page-item"><a className="page-link me-2" href="#">3</a></li>
    <li className="page-item"><a className="page-link" href="#">Next</a></li>
  </ul>
</nav>

    </div>
  )
}

export default Health
